import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { REPORT_GENERATION_AVERAGE_TIME } from '@/shared/config';

export const getReportGenerationInterval = (reportType: ReportType): number => {
  const reportAverageCreationTime =
    REPORT_GENERATION_AVERAGE_TIME[reportType] ||
    REPORT_GENERATION_AVERAGE_TIME[ReportType.ReportType_CBCT_GP];

  return Math.floor(reportAverageCreationTime / 100);
};
